var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.link}},[_c('button',{class:_vm.btnClass,attrs:{"type":"button","disabled":_vm.isLoading}},[_c('i',{class:_vm.btnIcon})])])}
var staticRenderFns = []

export { render, staticRenderFns }